import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-vh-100 d-flex flex-column" }
const _hoisted_2 = { class: "container-fluid px-md-5 flex-grow-1 d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.header_type)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(`${_ctx.header_type}-header`), { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view, {
        class: "flex-grow-1",
        onOpenAudioPlauer: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openAudioPlauer'))),
        onTvconnect: _ctx.tvconnect,
        onTvlist: _ctx.requestAvailableTvs
      }, null, 8, ["onTvconnect", "onTvlist"])
    ])
  ]))
}